<template>
  <RouterView></RouterView>
  <SharedSnackbar />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import SharedSnackbar from '@KTXC/components/shared/SharedSnackbar.vue';
</script>
